import { Toaster } from "react-hot-toast";
import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";

import Index from "./pages/Index.jsx";
import GoogleTranslate from "./GoogleTranslate.js";

const Loader = lazy(() => import("./components/Loader.jsx"));

const App = () => {
  return (
    <Suspense fallback={<Loader />}>
      <GoogleTranslate />
      <Toaster />
      <Routes>
        <Route path="/" element={<Index />} />
      </Routes>
    </Suspense>
  );
};

export default App;
